module.exports = __webpack_public_path__ + "static/media/arrow-down.7da2026c.svg";